import styled from 'styled-components';

export const Pane = styled.div`
  position: relative;
  display: flex;
  height: 100%;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
`;

/** Positioning context for the device anchors; the persistent preview host floats
 *  the live device(s) over the anchor boxes measured inside it. */
export const DeviceArea = styled.div`
  position: relative;
  min-height: 0;
  flex: 1;
  overflow: hidden;
`;

/** The centred region the device sits in. The inset mirrors the PAD_TOP / PAD_SIDE /
 *  PAD_BOTTOM constants in PreviewPane so the measured anchor lands inside it (the
 *  device fills this region; PreviewPane's belowLogo cap keeps it off the fixed logo). */
export const DeviceCenter = styled.div`
  position: absolute;
  inset: 24px 16px 0;
`;

/**
 * An empty, correctly-sized placeholder where one device should appear. The host
 * reads its rect and floats the matching warm iframe (with bezel) over it. Two of
 * these (phone + laptop) sit centred and overlapping; the host shows the active one
 * and parks the other off-canvas, so a device switch is an instant cross-slide.
 */
export const DeviceAnchor = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
`;

export const SwitchBar = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  /* The row's default flex align-items (stretch, not overridden) makes the device
     switcher grow to the tallest control beside it, so on tablet it matches the
     "Live Preview" pill's height without hard-coding either one. */
  gap: 12px;
  padding: 12px 0 24px;
  /* The device switcher stays interactive while the device area above it is
     click-through (so the live preview iframe can be scrolled). */
  pointer-events: auto;
`;
